import clsx from 'clsx';
import type { ChannelStatus } from '../api/channels.js';
import { t } from '../i18n/es.js';

type Tone = 'green' | 'red' | 'slate' | 'yellow';

const TONE_CLASS: Record<Tone, string> = {
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-800',
  slate: 'bg-slate-100 text-slate-700',
  yellow: 'bg-yellow-100 text-yellow-800',
};

export interface StatusBadgeProps {
  /** Channel status (default mode). */
  status?: ChannelStatus;
  /** Explicit label override (cuando se reusa para connectors/templates). */
  label?: string;
  /** Color tone explicit. */
  tone?: Tone;
}

export function StatusBadge({ status, label, tone }: StatusBadgeProps): JSX.Element {
  const resolvedTone: Tone =
    tone ??
    (status === 'connected'
      ? 'green'
      : status === 'disconnected'
        ? 'slate'
        : status === 'error'
          ? 'red'
          : 'slate');
  const resolvedLabel = label ?? (status ? t.channel.status[status] : '—');
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        TONE_CLASS[resolvedTone],
      )}
    >
      {resolvedLabel}
    </span>
  );
}
